/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBellRing = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M5.164 2.986C4.504 3.096 3 3.821 3 6H1c0-3.42 2.496-4.763 3.836-4.986zM21 6c0-2.18-1.504-2.903-2.164-3.014l.328-1.972C20.504 1.237 23 2.579 23 6zM5 9a7 7 0 0 1 14 0v2.036l.005.136a9.1 9.1 0 0 0 .328 2.04c.166.554.392 1.023.676 1.338.258.286.56.45.991.45v2H3v-2c.43 0 .733-.164.991-.45.284-.315.51-.784.676-1.337A9.095 9.095 0 0 0 5 11.036V11zm2 1v.75-.25.524a4.849 4.849 0 0 1-.007.234 11.073 11.073 0 0 1-.41 2.53A6.65 6.65 0 0 1 6.093 15h11.815a6.599 6.599 0 0 1-.49-1.213c-.213-.706-.316-1.4-.366-1.906a11.025 11.025 0 0 1-.051-.805v-.052L17 11.008V9A5 5 0 0 0 7 9zm8.92 9.393c-1.485 3.475-6.267 3.47-7.83.02l1.82-.826c.867 1.913 3.39 1.849 4.17.02z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgBellRing as BellRing };
